import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: '/',
    redirect: '/plist',
  },
  {
    path: "/plist",
    name: "plist",
    component: () => import( /* webpackChunkName: "plist" */ '../views/ProjectList.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.VUE_APP_GLOBAL_BASE_URL,
  routes,
});

export default router;
